var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResQSlider2 = function SvgResQSlider2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 920 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "resQ_Slider2_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f58940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "resQ_Slider2_svg__b",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f58840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "resQ_Slider2_svg__c",
    x1: 1.033,
    x2: 0.032,
    y1: 0.5,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f58b3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed595b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9735"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fcfcfc",
    stroke: "#fff",
    "data-name": "Rectangle 1583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 920,
    height: 480,
    stroke: "none",
    rx: 20
  }), /*#__PURE__*/React.createElement("rect", {
    width: 919,
    height: 479,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 19.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9732"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "M73 23h361v2H73z",
    "data-name": "Rectangle 1585"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "M481 23h363v2H481z",
    "data-name": "Rectangle 1586"
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": "Create New Project",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 15,
    fontWeight: 500,
    transform: "translate(1 99)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Create New Project")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-710 -372)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 14,
    fill: "#dae0f7",
    "data-name": "Rectangle 1584",
    rx: 7,
    transform: "translate(752 486)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#2647c9",
    "data-name": "In Progress",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 9,
    fontWeight: 500,
    transform: "translate(758 496)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "In Progress"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-596 -157)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "url(#resQ_Slider2_svg__a)",
    "data-name": "Ellipse 35",
    transform: "translate(645 157)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#resQ_Slider2_svg__b)",
    stroke: "#fff",
    "data-name": "Ellipse 36",
    transform: "translate(650 162)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-name": "Group 9727"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m661.812 185.637 5.174-1.046 9.555-11.371L671.6 169l-9.559 11.374-.23 5.264Zm2.215-4.492 7.812-9.292 1.875 1.6-7.817 9.3-1.956.4.088-2.005Z",
    "data-name": "Path 3302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.928 187.25h18.144v2.016h-18.144Z",
    "data-name": "Path 3303"
  }))), /*#__PURE__*/React.createElement("text", {
    fill: "#898989",
    "data-name": "Step 1",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 10,
    fontWeight: 500,
    transform: "translate(59 69)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "STEP 1")), /*#__PURE__*/React.createElement("text", {
    "data-name": "resQ Configuration",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 15,
    fontWeight: 500,
    transform: "translate(460 99)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -71.625,
    y: 0
  }, "resQ Configuration")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-321 -372)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 14,
    fill: "#e5e5e6",
    "data-name": "Rectangle 1584",
    rx: 7,
    transform: "translate(752 486)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#5a5961",
    "data-name": "Pending",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 9,
    fontWeight: 500,
    transform: "translate(759 496)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Pending"))), /*#__PURE__*/React.createElement("text", {
    fill: "#898989",
    "data-name": "Step 2",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 10,
    fontWeight: 500,
    transform: "translate(442 69)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "STEP 2")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-213 -157)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#cbcbcb",
    "data-name": "Ellipse 35",
    transform: "translate(645 157)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#cbcbcb",
    stroke: "#8d8d8d",
    "data-name": "Ellipse 36",
    transform: "translate(650 162)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M677.871 183.875a.5.5 0 0 1 .288-.288l1.93-.493v-4.27l-1.93-.493a.4.4 0 0 1-.288-.288 11 11 0 0 0-.534-1.314.48.48 0 0 1 0-.411l1.027-1.725-3.039-3.036-1.728 1.024a.37.37 0 0 1-.411 0 7.3 7.3 0 0 0-1.314-.534.5.5 0 0 1-.285-.29l-.452-1.889h-4.271l-.493 1.93a.4.4 0 0 1-.288.288 11 11 0 0 0-1.314.534.48.48 0 0 1-.411 0l-1.725-1.025-3.036 3.039 1.024 1.723a.37.37 0 0 1 0 .411 7.3 7.3 0 0 0-.534 1.314.5.5 0 0 1-.288.288l-1.889.452v4.312l1.93.493a.4.4 0 0 1 .288.288 11 11 0 0 0 .534 1.314.48.48 0 0 1 0 .411l-1.027 1.726 3.039 3.039 1.723-1.026a.37.37 0 0 1 .411 0 7.3 7.3 0 0 0 1.314.534.5.5 0 0 1 .288.288l.493 1.93h4.314l.493-1.93a.4.4 0 0 1 .288-.288 11 11 0 0 0 1.314-.534.48.48 0 0 1 .411 0l1.725 1.027 3.039-3.039-1.027-1.725a.37.37 0 0 1 0-.411 6.5 6.5 0 0 1 .411-1.355Zm-8.874 3.861a6.777 6.777 0 1 1 6.779-6.779 6.783 6.783 0 0 1-6.779 6.779",
    "data-name": "Path 3304"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "Extract Embed Code",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 15,
    fontWeight: 500,
    transform: "translate(767 99)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Extract Embed Code")), /*#__PURE__*/React.createElement("g", {
    "data-name": "pending",
    transform: "translate(66 -372)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 14,
    fill: "#e5e5e6",
    "data-name": "Rectangle 1584",
    rx: 7,
    transform: "translate(752 486)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#5a5961",
    "data-name": "Pending",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 9,
    fontWeight: 500,
    transform: "translate(759 496)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Pending"))), /*#__PURE__*/React.createElement("text", {
    fill: "#898989",
    "data-name": "Step 3",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 10,
    fontWeight: 500,
    transform: "translate(829 69)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "STEP 3")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9726",
    transform: "translate(175 -157)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#cbcbcb",
    "data-name": "Ellipse 35",
    transform: "translate(645 157)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#cbcbcb",
    stroke: "#8d8d8d",
    "data-name": "Ellipse 36",
    transform: "translate(650 162)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9728"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M663.096 174.634a1.553 1.553 0 0 0-2.171.329l-3.623 4.914a1.55 1.55 0 0 0 0 1.842l3.623 4.922a1.553 1.553 0 1 0 2.5-1.842l-2.943-4 2.943-4a1.553 1.553 0 0 0-.329-2.171Z",
    "data-name": "Path 3305"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.138 172.127a1.553 1.553 0 0 0-2.041.81l-6.206 14.5a1.551 1.551 0 1 0 2.851 1.223l6.214-14.491a1.553 1.553 0 0 0-.818-2.041Z",
    "data-name": "Path 3306"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.745 174.634a1.553 1.553 0 0 0-.329 2.171l2.95 4-2.95 4a1.555 1.555 0 1 0 2.507 1.842l3.623-4.922a1.55 1.55 0 0 0 0-1.842l-3.623-4.914a1.553 1.553 0 0 0-2.178-.329Z",
    "data-name": "Path 3307"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9729",
    transform: "translate(-1238 -157)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127.85,
    height: 50,
    fill: "url(#resQ_Slider2_svg__c)",
    rx: 25,
    transform: "translate(1238 587)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-SemiBold, Poppins",
    fontSize: 17,
    fontWeight: 600,
    transform: "translate(1271 617.837)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Cancel"))), /*#__PURE__*/React.createElement("g", {
    fill: "#fcfcfc",
    stroke: "#e0e0e0",
    "data-name": "Rectangle 1587",
    transform: "translate(0 152)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 920,
    height: 261,
    stroke: "none",
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 919,
    height: 260,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 4.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9730"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 79"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#ddd",
    "data-name": "input",
    transform: "translate(40 216)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 842,
    height: 50,
    stroke: "none",
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 841,
    height: 49,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 4.5
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#b2b2b2",
    "data-name": "Enter your project code",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 15,
    transform: "translate(60 231)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 16
  }, "Enter your project code"))), /*#__PURE__*/React.createElement("text", {
    "data-name": "Project Code",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 15,
    transform: "translate(40 187)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 16
  }, "Project Code"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9731"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 79"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#ddd",
    "data-name": "input",
    transform: "translate(40 325)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 842,
    height: 50,
    stroke: "none",
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 841,
    height: 49,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 4.5
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#b2b2b2",
    "data-name": "Enter your new project name",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 15,
    transform: "translate(60 340)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 16
  }, "Enter your new project name"))), /*#__PURE__*/React.createElement("text", {
    "data-name": "Project Name",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 15,
    transform: "translate(40 296)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 16
  }, "Project Name"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9736",
    transform: "translate(-445.851 -157)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127.85,
    height: 50,
    fill: "url(#resQ_Slider2_svg__c)",
    "data-name": "input",
    rx: 25,
    transform: "translate(1238 587)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-SemiBold, Poppins",
    fontSize: 17,
    fontWeight: 600,
    transform: "translate(1282 617.837)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Next"))))));
};
export default SvgResQSlider2;